module.exports = __webpack_public_path__ + "586601cf7ed9853dc51f58a371f5c5ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/category-3.jpg
// module id = ./assets/images/category-3.jpg
// module chunks = 0